import { WebWorkerMessageHandler } from '../../../../core/web-workers/web-worker-message-handler.model';
import { SignalRConnectionStatsService } from '../../../services/signalr-connection-stats-service';
import { LoggerService } from 'src/app/modules/core/services/logger/logger.service';
import { Logger } from 'src/app/modules/core/services/logger/logger.model';

export class ConnectionStatsHandler implements WebWorkerMessageHandler {
  private logger: Logger;

  public constructor(private statsService: SignalRConnectionStatsService, private loggerService: LoggerService) {
    this.logger = loggerService.getLogger('WebworkerClient.ConnectionStatsHandler');
  }

  processMessage(payload: any): void {
    const stats = payload;

    this.logger.logInfo('Received WebWorker connection stats', { stats });

    this.statsService.notifyChanged(stats);
  }
}
